import { Component, OnInit, AfterViewInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { Inspection, InspectionAssignment, InspectionFee, InspectionResult, InspectionStatuses as IST, InspectionTypes as ITPS,
  OffsiteFacility, OffsiteFacilityTypes } from '../shared/models/Inspection';
import { InspectionService } from '../shared/services/inspection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { PreviewModalService } from '../../shared/services/preview-modal.service';
import { SubDataVariables } from '../../../environments/app.variables';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ChangeStatusComponent } from '../change-status/change-status.component';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import {
  formatDisallowedTypeMessage,
  PDF_FILE_TOO_LARGE_MESSAGE
} from '../../shared/helpers/pdf-upload-validator';
import { environment } from '../../../environments/environment';
import { UserDto } from '../../models/User';
import { DocumentDetail } from '../../models/ApplicationDetail';
import { DocumentRef } from '../../models/DocumentRef';
import { CheckListValueModel, Document } from '../../models/ApplicationModel';
import * as Constants from '../../models/Constants';
import {saveAs} from 'file-saver';
import { CommonService } from '../../shared/services/common.service';
import { WorkflowActionModel } from '../../models/WorkflowActionModel';
import { PaymentReciptDoc } from '../../models/CommonModels';

@Component({
  selector: 'app-inspection-detail',
  templateUrl: './inspection-detail.component.html',
  styleUrls: ['./inspection-detail.component.css']
})
export class InspectionDetailComponent implements OnInit, AfterViewInit {

  public inspectionId: number;
  public inspection: Inspection;
  public detailReady: boolean = false;
  public activeTab: string;
  public inspectionStatuses: any = IST;
  public showInspectionResultTab: boolean = false;
  public showCapaAttachmentTab: boolean = false;
  public showTentativePlanAttachmentTab: boolean = false;
  public showInspectionReportAttachmentTab: boolean = false;
  public showTaskReviewUpdateAttachmentTab: boolean = false;
  public showImplementationReportAttachmentTab: boolean = false;
  public showDocumentsTab: boolean = false;
  public showPaymentTab: boolean = false;
  public showUploadFeeTab: boolean = false;
  public showChecklistTab: boolean = false;
  public showPaymentVerificationActions: boolean = false;
  public showGMPSuspensionLetter: boolean = false;
  public showGMPCancellationLetter : boolean = false;
  public showGMPRevocationLetter : boolean = false;
  public showInspectionActions: boolean = false;
  public showSubmitFileForPreparationActions: boolean = false;
  public showDeleteQRCodeButton: boolean = false;
  public noCapa: boolean = false;
  public uploader: FileUploader;
  public uploaderLargeFile: FileUploader;
  public uploaderVeryLargeFile: FileUploader;
  public inspectionDocUploadUrl = environment.baseUrl + '/Attachment/Inspection';
  public bothCapaAndImplementation: boolean = false;
  //Might need to decrease it back to 6 MB
  //private maxFileSize: number = 6 * 1024 * 1024;
  private maxFileSize: number = 25 * 1024 * 1024;
  private maxFileSizeInspectionResult: number = 15 * 1024 * 1024;
  private veryMaxFileSizeDocument: number = 25 * 1024 * 1024;
  private allowedFileType = ['pdf'];
  public uploadErrorMessage: string;
  public currentUser: UserDto;
  public documents: Array<Document> = [];
  public editDocuments: Array<DocumentDetail> = [];
  public documentRefs: Array<DocumentRef> = [];
  public uploadedFinalDocuments: Array<DocumentRef> = [];
  public uploadedTentativePlanDocuments: Array<DocumentRef> = [];
  public capaDocRefs:Array<DocumentRef> = [];
  public implementationDocRefs:Array<DocumentRef> = [];
  public paymentDocRefs: Array<DocumentRef> = [];
  public paymentUploadedRef:Array<DocumentRef> = [];
  public finalFileDocRefs: Array<DocumentRef> = [];
  public inspectionDocRefs: Array<DocumentRef> = [];
  public serviceFeeReference: DocumentRef;
  public attachedDocs: Array<any> = [];
  public isAbroadCGMP: boolean = false;
  public isLocalGMP: boolean = false;
  public isAbroadWaiver: boolean = false;
  public isAbroadOnly: boolean = false;
  public isGMP : boolean = false;
  public isNewGMP : boolean = false;
  public historyLog: any;
  public inspectionProcessingTime: any;
  public inspectionListUrl: string = "";
  public constants: any = Constants;
  public showEnketoForm = false;
  public currentInspectionResult = null;
  public showFileColumnsInspectionResult: boolean;
  public showOdkColumnsInspectionResult: boolean;
  public inspectionResults: InspectionResult[];
  public inspectionResultDocuments: any[];
  public isSra: boolean = false;
  public multipleFacilityFees: InspectionFee[] = [];
  public productionLineCount: number = 0;
  public moreThan2ProdLineFees: InspectionFee;
  public totalAppliedFeeAmount: number = 0;
  public paymentAddrFee:InspectionFee;
  public sraFee: InspectionFee;
  public multipleOffsiteFacilityFee: InspectionFee;
  public categoryId : number = 0;
  public agencyId : number = 0;
  public applicantTypeId : number = 0;
  public isGMPFinalPayment: boolean = false;
  public isMultiPaymentUpload: boolean = false;
  public isProofOfPaymentFromEFDAFinance: boolean = false;
  public isBankTransferSlip: boolean = false;
  public showSubmittedFinalDocuments: boolean = false;
  public showSubmittedTentativePlanDocuments: boolean = false;
  public workflowUrl: string;
  public itps = ITPS;
  public keyPersons: any[] = []; //keypersons of abroad facility\
  public modalRef: any;
  public expandedProdDetailIds: number[] = [];
  public offsiteFacilityTypes: any = OffsiteFacilityTypes;
  public totalOffsiteFacilities: OffsiteFacility[] = [];
  public uniqueOffsiteFacilitiesByNameAndAddressCount : number = 0;
 public hasPartialApprovalRecommend: boolean = false;
  public showRtiInspectionDocumentEdit = false;
  public rtiInspectionDocRefs: DocumentRef[] = [];
  public rtiEditDocuments: DocumentDetail[] = [];
  public rtiDocuments: Document[] = [];
  private readonly rtiInspectionReportDocNames = new Set<string>([
    Constants.INSPECTION_REPORT,
    Constants.DEFICIENCY_REPORT,
    Constants.ATTENDANCE_SHEET,
    Constants.INSPECTION_PHOTOS,
    Constants.DECLARATIN_LETTER_LINE_EXEMPTION_INSPECTION
  ]);


  constructor(private route: ActivatedRoute, private inspectionService: InspectionService, private accountService: AccountService,
    private spinner: NgxSpinnerService, private alertService: AlertService, private previewService: PreviewModalService,
    private modalService: BsModalService, private router: Router, private commonService : CommonService) { }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: this.inspectionDocUploadUrl,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accountService.getTokenData() }]
    });
    this.uploaderLargeFile = new FileUploader({
      url: this.inspectionDocUploadUrl,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSizeInspectionResult,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accountService.getTokenData() }]
    });
  this.uploaderVeryLargeFile = new FileUploader({
      url: this.inspectionDocUploadUrl,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.veryMaxFileSizeDocument,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accountService.getTokenData() }]
    });
    this.uploaderLargeFile.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
    this.currentUser = this.accountService.getUserData();
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    switch (filter.name) {
      case 'fileSize':
        this.uploadErrorMessage = PDF_FILE_TOO_LARGE_MESSAGE;
        break;
      case 'fileType':
        this.uploadErrorMessage = formatDisallowedTypeMessage(item.type || 'unknown');
        break;
      default:
        this.uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
    }
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      this.inspectionId = params['id'];
      this.getInspection();
      this.getInspectionHistory(this.inspectionId);
      this.GetInspectionProcessingTime(this.inspectionId);
    });
  }

  activateTab(tab) {
    this.activeTab = tab;
    $('.nav-tabs a[href="#' + tab + '"]').tab('show');
  };

  getInspection(){
    this.workflowUrl = `${environment.baseUrl}/Workflow/Inspect/GetNextStates/${this.inspectionId}`;
    this.inspectionService.getInspection(this.inspectionId).subscribe(resp => {
      if (!resp) {
        this.alertService.error('Unable to load inspection ' + this.inspectionId + '. The API returned no data.');
        return;
      }
      this.inspection = resp;
      this.getInspectionHistory(this.inspectionId);
      this.inspection.documents = (this.inspection.documents || []).sort((a, b) => b.id - a.id);
      this.categoryId = resp.productionInfo?.approvalMethodID;
      this.agencyId = resp.productionInfo?.agencyID;
      if(resp.inspectionAbroadFacility?.length > 0) {
        this.applicantTypeId = resp.inspectionAbroadFacility[0].applicantTypeID
      } else if (resp.userDto?.applicantTypeId) {
        this.applicantTypeId = resp.userDto.applicantTypeId;
      }

      if(this.inspection.productionInfo && this.inspection.productionInfo.productDetails?.length > 0) {
        var prodDetails = this.inspection.productionInfo.productDetails;
        const { totalOffsiteFacilities, uniqueOffsiteFacilitiesByNameAndAddressCount } =
            this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)
        this.totalOffsiteFacilities = totalOffsiteFacilities;
        this.uniqueOffsiteFacilitiesByNameAndAddressCount = uniqueOffsiteFacilitiesByNameAndAddressCount;
      }

      this.inspectionListUrl = this.inspectionService.getInspectionListUrl(this.inspection);
      this.inspection.inspectionNumber = '0'.repeat(Math.max(5, this.inspection.id.toString().length) - this.inspection.id.toString().length) + this.inspection.id +
                                            this.inspection.inspectionNumber;

      if(this.inspection.previousInspectionID){
        this.inspection.previousInspectionNumber = '0'.repeat(Math.max(5, this.inspection.previousInspectionID.toString().length) - this.inspection.previousInspectionID.toString().length) +
                    this.inspection.previousInspectionID + this.inspection.previousInspectionNumber;
      }

      this.isAbroadCGMP = [ITPS.NEW_ABROAD_CGMP_INSPECTION, ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER,ITPS.ABROAD_CGMP_RENEWAL_INSPECTION,
         ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL, ITPS.ABROAD_CGMP_LINE_ADDITION_INSPECTION].indexOf(this.inspection.type.inspectionTypeCode) !== -1;

      this.isLocalGMP = [ITPS.LOCAL_GMP_RENEWAL_INSPECTION, ITPS.NEW_LOCAL_GMP_INSPECTION].indexOf(this.inspection.type.inspectionTypeCode) !== -1;

      this.isAbroadWaiver = [ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER, ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL].indexOf(this.inspection.type.inspectionTypeCode) != -1;

      this.isGMP = this.isAbroadCGMP || this.isLocalGMP;
      this.isNewGMP = (ITPS.NEW_ABROAD_CGMP_INSPECTION === this.inspection.type.inspectionTypeCode )
      this.isAbroadOnly = [ITPS.NEW_ABROAD_CGMP_INSPECTION,ITPS.ABROAD_CGMP_RENEWAL_INSPECTION].indexOf(this.inspection.type.inspectionTypeCode) !== -1;

      this.detailReady = true;
      this.attachedDocs = this.inspection.documents;

      if(!this.accountService.isUserFinancialOfficer()) {
        this.activateTab('inspectionInfo');
      } else {
        if(this.isAbroadCGMP && this.inspection.inspectionAbroadFacility?.length > 0) {
          this.activateTab('abroadFacilityInfo');
        } else if (this.inspection.facilityInfo) {
          this.activateTab('facilityInfo');
        } else if (this.inspection.productionInfo) {
          this.activateTab('productionInfo');
        } else {
          this.activateTab('inspectionInfo');
        }
      }

      this.setActionButtons();
      this.addPaymentLetter();

      if(this.isAbroadCGMP) {
        this.fillKeyPersons();
      }

      this.inspectionService.getAllUserUploadedDocRefs(this.inspection.type.inspectionTypeCode, this.categoryId, this.agencyId, this.applicantTypeId).subscribe(documentRefsResp => {
         //this.documentRefs = [];
          this.paymentDocRefs = [];
          this.capaDocRefs = [];
          this.implementationDocRefs = [];
          this.paymentUploadedRef = [];
          this.isMultiPaymentUpload = false; 
        for (let i = 0; i < documentRefsResp.length; i++) {
          this.documentRefs.push(documentRefsResp[i]);
          if(documentRefsResp[i].name == Constants.PAYMENT_DOC_NAME && ([IST.SCREENING_PASSED, IST.RECOMMEND_FOR_PAYMENT_FAILURE,IST.PAYMENT_REQUEST_LETTER_GENERATED].indexOf( this.inspection.status.inspectionStatusCode) !== -1 && !this.isLocalGMP)){
            this.paymentDocRefs.push(documentRefsResp[i]);
            }
          else if(documentRefsResp[i].name == Constants.CAPA_DOC_NAME){
            this.capaDocRefs.push(documentRefsResp[i]);
          } else if(documentRefsResp[i].name == Constants.IMPLEMNTATION_REPORT_DOC_NAME){ 
            this.implementationDocRefs.push(documentRefsResp[i]);
          }
          else if((documentRefsResp[i].name == Constants.BANK_TRANSFER_SLIP || documentRefsResp[i].name == Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE) 
            && ([IST.SCREENING_PASSED, IST.RETURN_TO_APPLICANT,IST.PAYMENT_REQUEST_LETTER_GENERATED].indexOf( this.inspection.status.inspectionStatusCode) !== -1)){
           this.isMultiPaymentUpload=true;
            this.paymentUploadedRef.push({
                ...documentRefsResp[i],
                 receipt: ''
            });  
          }
        }

        this.configureGmpFinalPaymentUpload();

       // let emptyDocRefs = this.documentRefs.filter(d => this.inspection.documents.map(m => m.referenceID).indexOf(d.id) == -1 &&
         // [Constants.PAYMENT_DOC_NAME,Constants.BANK_TRANSFER_SLIP,Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE, Constants.CAPA_DOC_NAME].indexOf(d.name) != -1);

       // this.documentRefs = this.documentRefs.filter(d => emptyDocRefs.map(m => m.id).indexOf(d.id) == -1);
        
       let emptyDocRefs = this.documentRefs.filter(d =>
              this.inspection.documents.map(m => m.referenceID).indexOf(d.id) === -1
              || d.name == Constants.TASK_FORCE_REVIEW_MINUTE_DOC_NAME || d.name == Constants.GMP_APPLICATION_FORM
             );

          this.documentRefs = this.documentRefs.filter(d =>
            emptyDocRefs.map(m => m.id).indexOf(d.id) === -1
          );
       this.showDocumentsTab = this.documentRefs.length > 0;

        if(this.accountService.isUserFinancialOfficer()) {
          this.documentRefs = this.documentRefs.filter(d => [Constants.PAYMENT_DOC_NAME, Constants.PAYMENT_REQUEST_DOC_NAME, Constants.BANK_TRANSFER_SLIP
            , Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE, Constants.GMP_FINAL_PAYMENT_DOC_NAME,
            Constants.GMP_FINAL_BANK_TRANSFER_SLIP, Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE ].includes(d.name));
        }
      });

      if(this.showSubmittedFinalDocuments){  
          this.uploadedFinalDocuments = this.inspection.documents.filter(d => [Constants.TASK_FORCE_REVIEW_MINUTE_DOC_NAME].indexOf(d.documentReference.name) != -1).map(d => d.documentReference);
        // if(this.accountService.isUserApplicant() || this.accountService.isUserRegistrant()) { 
        //   this.uploadedFinalDocuments = this.inspection.documents.filter(d => [Constants.INSPECTION_AGENDA,Constants.TASK_FORCE_REVIEW_MINUTE_DOC_NAME].indexOf(d.documentReference.name) != -1).map(d => d.documentReference);
        // } else { 
        //   this.uploadedFinalDocuments = this.inspection.documents.filter(d => [Constants.PREPARATION_CHECKLIST,Constants.VISA, Constants.CONFLICT_OF_INTEREST,
        //     Constants.CONSENT_FORM_DOC, Constants.INSPECTION_AGENDA].indexOf(d.documentReference.name) == -1).map(d => d.documentReference);
        // } 
      }
      
      if(this.showSubmittedTentativePlanDocuments){ 
          this.uploadedTentativePlanDocuments = this.inspection.documents.filter(d => [Constants.PREPARATION_CHECKLIST, Constants.CONFLICT_OF_INTEREST, Constants.CONSENT_FORM_DOC,
            Constants.VISA,Constants.INSPECTION_AGENDA].indexOf(d.documentReference.name) != -1).map(d => d.documentReference);
       }

      if(this.showPaymentVerificationActions){
        this.commonService.getDocRefByName(Constants.SERVICE_FEE_REFERENCE).subscribe(documentRefsResp => {
          this.serviceFeeReference = documentRefsResp;
        });
      }

      if (this.inspection.screeningChecklists?.length) {
        this.showChecklistTab = true;
        this.inspection.screeningChecklists.forEach(function (checklist) {
          if (checklist.screenerResponseValue === null) {
            checklist.screenerResponseValue = new CheckListValueModel();
          }
        });
      }

      if(this.inspection.appliedFees && this.inspection.appliedFees.length > 0){
        this.isSra = this.inspection.appliedFees.findIndex(f => f.isSra == true) > -1;
        if(this.isSra){
          this.sraFee = this.inspection.appliedFees.find(f => f.isSra == true);
          this.totalAppliedFeeAmount += this.inspection.appliedFees.find(f => f.isSra == true).amount;
        } else {
          this.paymentAddrFee = this.inspection.appliedFees.find(f => f.isSra == false && f.hasMultipleFacility == false && f.code != 'MTTP' && f.code != 'MOF');
          if(this.paymentAddrFee){
            this.totalAppliedFeeAmount += this.paymentAddrFee.amount;
          }
        }
        this.multipleFacilityFees = this.inspection.appliedFees.filter(f => f.hasMultipleFacility == true);
        this.multipleFacilityFees.forEach(f => this.totalAppliedFeeAmount += f.amount);
        this.moreThan2ProdLineFees = this.inspection.appliedFees.find(f => f.code == 'MTTP');
        if(this.moreThan2ProdLineFees){
          this.productionLineCount = this.inspectionService.countProductionLinesForFee(this.inspection.productionInfo?.productDetails);
          this.totalAppliedFeeAmount += this.moreThan2ProdLineFees.amount * Math.max(0, this.productionLineCount - 2);
        }
        this.multipleOffsiteFacilityFee = this.inspection.appliedFees.find(f => f.code == 'MOF');
        if(this.multipleOffsiteFacilityFee) {
          this.totalAppliedFeeAmount += (this.multipleOffsiteFacilityFee.amount * (this.uniqueOffsiteFacilitiesByNameAndAddressCount));
        }
      }
    }, err => {
      this.alertService.error('Unable to load inspection ' + this.inspectionId + '.');
    });
  }

  getApplicationNumber(selectedFacility) {
    return '0'.repeat(Math.max(5, selectedFacility.applicationID.toString().length) - selectedFacility.applicationID.toString().length) + selectedFacility.applicationID +
        selectedFacility.applicationNumber
  }

 
  getDateString(inputDate) {
    let date = new Date(inputDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'});
  }

  setActionButtons() {
    let statusCode = this.inspection.status.inspectionStatusCode;
    let inspectionTypeCode = this.inspection.type.inspectionTypeCode

    if(this.isGMP && this.accountService.isUserGMPCoordinator()){
      this.showPaymentVerificationActions = statusCode == IST.FEE_ATTACHED;
    }

    this.showGMPSuspensionLetter = this.isGMP && statusCode == IST.GMP_SUSPENDED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.SUSPENSION_LETTER_DOC_NAME) !== -1;
    this.showGMPCancellationLetter = this.isGMP && statusCode == IST.GMP_CANCELLED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.CANCELLATION_LETTER_DOC_NAME) !== -1;
    this.showGMPRevocationLetter = this.isGMP && statusCode == IST.GMP_REVOKED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.REVOCATION_LETTER_DOC_NAME) !== -1;
    
    let tentativePlanDocs = this.inspection.documents.filter(d => [Constants.PREPARATION_CHECKLIST, Constants.CONFLICT_OF_INTEREST, Constants.CONSENT_FORM_DOC,Constants.INSPECTION_AGENDA,
      Constants.VISA ].indexOf(d.documentReference.name) != -1);

    let finalFileDocs = this.inspection.documents.filter(d => [ Constants.TASK_FORCE_REVIEW_MINUTE_DOC_NAME].indexOf(d.documentReference.name) != -1);

  //  this.showSubmittedFinalDocuments = this.isGMP && finalFileDocs.length > 0 && !this.accountService.isUserTaskForce();
 
  this.showSubmittedFinalDocuments = this.isGMP && (!this.accountService.isUserApplicant()
     && !this.accountService.isUserRegistrant())&& finalFileDocs.length>0; 
  if(this.accountService.isUserApplicant() &&(statusCode == IST.TENTATIVE_PLAN_SUBMIT || statusCode == IST.TENTATIVE_PLAN_RETURNED || statusCode == IST.TENTATIVE_PLAN_APPROVED)){
  this.showSubmittedTentativePlanDocuments =false
  }
  else if(this.accountService.isUserApplicant() ){
  this.showSubmittedTentativePlanDocuments = this.isGMP&&  tentativePlanDocs.length >0 ;
  }
  else if(!this.accountService.isUserApplicant() ) {
  this.showSubmittedTentativePlanDocuments = this.isGMP && tentativePlanDocs.length >0;  
  }
  
    if(statusCode == IST.INSPECTED_CODE){
      this.activateTab("inspectionRes");
    } 
    if(this.inspection.inspectionResults && this.inspection.inspectionResults.length > 0){
        const disallowedStatuses = [IST.TASK_FORCE_REVIEW_REPORT_UPDATED, IST.RECOMMEND_FOR_APPROVAL_CODE, IST.RECOMMEND_FOR_REJECTION_CODE,
           IST.CAPA_PLAN_RECOMMEND, IST.PARTIAL_APPROVAL_RECOMMENDED, IST.RECOMMENDED_FOR_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE,
          IST.RECOMMENDED_FOR_REJECTION_AFTER_IMPLEMENTATION_EVIDENCE, IST.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE];
             
      //for non-gmp don't show the tab for applicant for gmp show the inspection result tab for all roles
    this.showInspectionResultTab =
  (!this.isGMP && this.accountService.isNotApplicant()) || // not GMP and not applicant
  (this.isGMP  && (
    (this.accountService.isNotApplicant() && !this.accountService.isUserRegistrant()) || // GMP and not applicant — always allowed
    (this.accountService.isUserApplicant() && !disallowedStatuses.includes(statusCode)) // GMP and applicant and allowed status
  ));
  console.log(       this.accountService.isNotApplicant()  );
    this.inspectionResults = this.inspection.inspectionResults.reverse();
      this.inspectionResults.map(result => {
          if(!this.isGMP) {
            if(result.documentID){
              this.showFileColumnsInspectionResult = true;
              let fileName = result.document.filePath;
              if(fileName){
                fileName = fileName.replace(/^.*[\\\/]/, '');
                !fileName.length ? result.fileName = '-' : result.fileName = fileName;
              }else {
                result.fileName = '-';
              }
            }

            if(result.odkResponseUUID){
              this.showOdkColumnsInspectionResult = true;
            }

            result.inspectionIdentifier = result.inspectionIdentifier || '-';
            result.odkFormUploadDate = result.odkFormUploadDate ? this.getDateString(result.odkFormUploadDate) : '-';
            result.uploadedTime = result.createdDate ? this.getDateString(result.createdDate) : '-';

          } else {

            result.inspectionResultDocuments.map(resultDoc => {
              let fileName = resultDoc.inspectionDocument.filePath;
              if(fileName){
                fileName = fileName.replace(/^.*[\\\/]/, '');
                !fileName.length ? resultDoc.fileName = '-' : resultDoc.fileName = fileName;
              }else {
                resultDoc.fileName = '-';
              }
            });
 
               if  ((this.isAbroadCGMP || this.isLocalGMP) && (this.accountService.isUserApplicant() || this.accountService.isUserRegistrant()) ){ 
             
               if (result.statusName === 'Task Force Review Report Updated') {
                    const removeDoc = Constants.INSPECTION_REPORT;
                    const requiredDocs = [
                        Constants.DEFICIENCY_REPORT, 
                        Constants.ATTENDANCE_SHEET, 
                        Constants.DECLARATIN_LETTER_LINE_EXEMPTION_INSPECTION,
                        Constants.INSPECTION_PHOTOS
                    ];

                    const taskForceDocs = (result.inspectionResultDocuments || [])
            .filter(d => d.inspectionDocument?.documentReference?.name !== removeDoc);
            
                  const submittedResult = this.inspectionResults.find(
                  r => r.statusName === 'Inspection Report Submitted'
              );
              const submittedDocs = submittedResult?.inspectionResultDocuments || [];
               const finalDocs: any[] = [];
              requiredDocs.forEach(docName => {
                  let doc = taskForceDocs.find(d => d.inspectionDocument?.documentReference?.name === docName);
                  if (!doc) {
                      doc = submittedDocs.find(d => d.inspectionDocument?.documentReference?.name === docName);
                  }
                  if (doc) finalDocs.push(doc);
              });
                      result.inspectionResultDocuments = finalDocs;
              }
             else {
              result.inspectionResultDocuments = []; 
               result.statusName = null;
             }
             
            }
            // applicant can only see the deficiency report document uploaded by the inspector
           else if (this.accountService.isUserApplicant() || this.accountService.isUserRegistrant()) {
              result.inspectionResultDocuments = result.inspectionResultDocuments.filter(d => d.inspectionDocument?.documentReference?.name === Constants.DEFICIENCY_REPORT);
            }
          
            // task force role can only see inspection report and deficiency report
            else if(!this.isGMP && this.accountService.isUserTaskForce()) {
              result.taskForceReportDocument = result.inspectionResultDocuments.find(d => d.inspectionDocument?.documentReference?.name === Constants.TASK_FORCE_REPORT_DOC_NAME);
              result.inspectionResultDocuments = result.inspectionResultDocuments.filter(d => [Constants.DEFICIENCY_REPORT,
                  Constants.INSPECTION_REPORT].includes(d.inspectionDocument?.documentReference?.name) );
            } 
            else if(this.isGMP) { 
                  result.taskForceReportDocument = result.inspectionResultDocuments.find(d => d.inspectionDocument?.documentReference?.name === Constants.TASK_FORCE_REPORT_DOC_NAME);
                result.inspectionResultDocuments = result.inspectionResultDocuments.filter(d => [Constants.DEFICIENCY_REPORT, Constants.ATTENDANCE_SHEET, Constants.DECLARATIN_LETTER_LINE_EXEMPTION_INSPECTION,
                Constants.INSPECTION_PHOTOS ,  Constants.INSPECTION_REPORT].includes(d.inspectionDocument?.documentReference?.name) );
            }
            else {
              result.taskForceReportDocument = result.inspectionResultDocuments.find(d => d.inspectionDocument?.documentReference?.name === Constants.TASK_FORCE_REPORT_DOC_NAME);
              result.inspectionResultDocuments = result.inspectionResultDocuments.filter(d => d.inspectionDocument?.documentReference?.name !== Constants.TASK_FORCE_REPORT_DOC_NAME);
            }
            
          }

          return result;
      });
    }

    this.noCapa =  [ITPS.INVESTIGATION_INSPECTION, ITPS.INFORMAL_MARKET_INSPECTION].indexOf(inspectionTypeCode) > -1;

    this.showDeleteQRCodeButton = !this.isGMP && this.accountService.isUserSuperAdmin() && [ IST.REQUESTED_CODE,
      IST.ASSIGNED_TO_INSPECTOR, IST.ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION, IST.ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE].indexOf(this.inspection.status.inspectionStatusCode) !== -1 && this.isInspectionQRCodeDocAlreadyCreated();

    this.setupRtiDocumentEdit();
  }

  isUserAssignedToApplication(): boolean {
    return this.inspection.inspectionAssignments.find(obj => obj.userID === this.accountService.getUserData().id
              && obj.primary) !== undefined;
  }

  private isFinalPaymentUploadStatus(): boolean {
    const statusCode = this.inspection?.status?.inspectionStatusCode;
    return statusCode === IST.FINAL_PAYMENT_REQUESTED || statusCode === IST.FINAL_PAYMENT_RETURNED;
  }

  private configureGmpFinalPaymentUpload() {
    if (!this.isFinalPaymentUploadStatus()) {
      return;
    }

    if (this.isAbroadWaiver) {
      this.isGMPFinalPayment = true;
      this.isMultiPaymentUpload = false;
      if (!this.paymentDocRefs.some(ref => ref.id === Constants.GMP_FINAL_PAYMENT_REFERENCE_ID)) {
        this.paymentDocRefs.push({
          id: Constants.GMP_FINAL_PAYMENT_REFERENCE_ID,
          name: Constants.GMP_FINAL_PAYMENT_DOC_NAME,
          description: Constants.GMP_FINAL_PAYMENT_DOC_NAME,
          required: true
        });
      }
      return;
    }

    if (this.isGMP) {
      this.ensureGmpFinalPaymentDocRefs();
    }
  }

  ensureGmpFinalPaymentDocRefs() {
    this.isMultiPaymentUpload = true;
    this.isGMPFinalPayment = true;
    const target = this.paymentUploadedRef;
    const needed = [
      {
        id: Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID,
        name: Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE,
        description: Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE,
        required: true,
        receipt: ''
      },
      {
        id: Constants.GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID,
        name: Constants.GMP_FINAL_BANK_TRANSFER_SLIP,
        description: Constants.GMP_FINAL_BANK_TRANSFER_SLIP,
        required: true,
        receipt: ''
      }
    ];
    needed.forEach(ref => {
      if (!target.some(existing => existing.id === ref.id)) {
        target.push(ref);
      }
    });
  }

  isSubmitFileDisabled(){
    if(this.isLocalGMP){
      return this.documents.length < 2;
    }else{
      return this.documents.length < 4;
    }
  }

   isRequiredDocUploaded():boolean {
    var upDocs = JSON.stringify(this.documents.map(d => d.referenceID));
    var inspDocRefs = this.inspectionDocRefs.filter(d => d.required == true).map(d => d.id);
    if(inspDocRefs.every(r => upDocs.includes(r.toString()))){
      return false;
    }
      return true;
  }

  showGenerateInspectionQRCodeDocButton(){
    return [ IST.REQUESTED_CODE, IST.ASSIGNED_TO_INSPECTOR, IST.ASSIGNED_TO_INSPECTOR_AFTER_INSPECTION, IST.ASSIGNED_TO_INSPECTOR_AFTER_IMPLEMENTATION_EVIDENCE].indexOf(this.inspection.status.inspectionStatusCode) !== -1
       && !this.isInspectionQRCodeDocAlreadyCreated();
  }

  isInspectionQRCodeDocAlreadyCreated(){
    let submittedInspectionOdkIds = this.inspection.inspectionResults.map(i => i.inspectionIdentifier);
    let qrCodeDocs = this.inspection.documents.filter(d => d.referenceID == 64 && submittedInspectionOdkIds.indexOf(d.remark) === -1); // inspection QR code document
    return qrCodeDocs.length !== 0;
  }

  generateInspectionQRCode(){
    this.spinner.show();
    this.inspectionService.generateInspectionQRCode(this.inspection.id).subscribe(doc => {
      this.spinner.hide();
      if(doc){
        this.inspection.documents.push(doc);
        this.alertService.success("Inspection QR Code document generated successfully!")
      }else {
        this.alertService.success("Couldn't generate the Inspection QR Code document, please try again!")
      }
    }, err => {
      this.spinner.hide();
      this.alertService.success("Couldn't generate the Inspection QR Code document, please try again!") 
    });
  }

  showInspectionQRCodeDocument(){
    const attachmentUrl = SubDataVariables.INSPECTION_QRCODE_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Inspection", true);
  }

  showStatusChangeModal(newStatusCode){ 
    const initialState = {
      docs: this.documents,
      isPartialApprovalRecommended: (newStatusCode == IST.PARTIAL_APPROVAL_RECOMMENDED)||  (newStatusCode == IST.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE),
      isCapaRecommend:newStatusCode == IST.CAPA_PLAN_RECOMMEND,
      isInspectionReportSubmitted: newStatusCode == IST.INSPECTION_REPORT_SUBMITED,
      isPartialApprovalLetterGenerated: newStatusCode == IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE,
      hasPartialApprovalRecommend: this.hasPartialApprovalRecommend,
      newStatusCode: newStatusCode,
      inspection: this.inspection,
      showInspectionActions: this.showInspectionActions && newStatusCode != IST.WITHDRAWN,
      isGMP: this.isGMP
    };
    
    this.modalService.show(ChangeStatusComponent, {
      initialState,
      class: 'modal-md',
      backdrop: 'static'
    });
    
  }

  inspectionDocPreviewModal(fileName, documentId){
      const attachmentUrl = SubDataVariables.INSPECTION_DOC_URL + '/' + documentId;
      this.previewService.openModal(attachmentUrl, fileName, true);
  }

  odkPreviewModal(inspectionResult : InspectionResult){
    // the new inspection result from odk virtual form
    this.currentInspectionResult = inspectionResult;
    this.showEnketoForm = true;
  }

  isInspectionLegacyData(){
    return this.inspection.isLegacyData;
  }

  isLetterGenerated(){
    let statusCode = this.inspection.status.inspectionStatusCode;
    let letterGenertedStatuses = [IST.PRODUCT_RECALLED_CODE, IST.LICENSE_CANCELLED_CODE,
      IST.LICENSE_SUSPENDED_CODE, IST.WARNING_GIVEN_CODE, IST.FORWARDED_FOR_FOLLOW_UP_INSPECTION,
      IST.RETURN_TO_APPLICANT,IST.RETURNED_TO_APPLICANT_TO_COMPLETE_APPLICATION, IST.SCREENING_FAILED, 
      IST.APPROVAL_LETTER_GENERATED_WITH_CAPA, IST.REJECTED];

    if(letterGenertedStatuses.findIndex(m => m === statusCode) != -1 || (!this.isGMP && statusCode == IST.APPROVAL_LETTER_GENERATED_CODE)){
      return true;
    }
    return false;
  }
  isRTA(){
   let statusCode = this.inspection.status.inspectionStatusCode; 
       if(statusCode == IST.RETURN_TO_APPLICANT){
      return true;
    }
    return false;
  }
isPartialApprovalLetterGenerated(){
   let statusCode = this.inspection.status.inspectionStatusCode; 
       if(statusCode == IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE){
      return true;
    }
    return false;
  }
  isNonComplianceLetterGenerated(){
   let statusCode = this.inspection.status.inspectionStatusCode; 
       if(statusCode == IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE || statusCode == IST.NON_COMPLIANCE_LETTER_GENERATED){
      return true;
    }
    return false;
  }
  
  isApprovalLetterGenerated(){
    let statusCode = this.inspection.status.inspectionStatusCode;
    if(statusCode == IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE 
      || statusCode == IST.APPROVAL_LETTER_GENERATED_CODE){
      return true;
    }
    return false;
  }

  isSupportLetterGenerated(){ 
    let statusCode = this.inspection.status.inspectionStatusCode; 
    if(this.isAbroadOnly || this.isLocalGMP){
      return false;
    }
   
   else if([
       IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE, IST.APPROVAL_LETTER_GENERATED_CODE,
       IST.CAPA_PLAN_REQUESTED, IST.CAPA_PLAN_SUBMITTED].indexOf(statusCode) != -1
      && this.getDocument(this.constants.SUPPORT_LETTER_REFERENCE_ID)){
      return true;
    }
    return false;
  }

  showGeneratedLetter(){
    let attachmentUrl = SubDataVariables.INSPECTION_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Generated Letter" , true);
  }

  showPaymentLetter(){
    const paymentDoc = this.attachedDocs?.find(
      doc => doc.documentReference?.name === Constants.PAYMENT_REQUEST_DOC_NAME
    );
    if (paymentDoc?.id) {
      const attachmentUrl = SubDataVariables.INSPECTION_DOC_URL + '/' + paymentDoc.id;
      this.previewService.openModal(attachmentUrl, "Payment Letter", true);
      return;
    }
    // Fallback: status-aware InspectionLetter API (not the shared unfiltered bag)
    this.showGeneratedLetter();
  }

  showGeneratedCertificate(){
    let attachmentUrl = SubDataVariables.GMP_CERTIFICATE_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Generated Certificate" , true);
  }

  isCertificateGenerated(){
    return this.isGMP && [IST.APPROVAL_LETTER_GENERATED_CODE, IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE].indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }
    isCertificateLetterGenerated(){
    return !this.isGMP && [IST.APPROVAL_LETTER_GENERATED_CODE, IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE].indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  showDeficiencyLetter(){
    const attachmentUrl = SubDataVariables.DEFICIENCY_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Deficiency Letter", true);
  }
    showNonComplianceLetter(){
    const attachmentUrl = SubDataVariables.NON_COMPLIANCE_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Non Compliance Letter", true);
  }
  
    showComplianceLetter(){
    const attachmentUrl = SubDataVariables.COMPLIANCE_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Cover Letter", true);
  }

  showPaymentReference(){
    const attachmentUrl = SubDataVariables.SYSTEM_FILE_URL + '/' + Constants.SERVICE_FEE_REFERENCE + '/' + null;
    this.previewService.openModal(attachmentUrl, "Letter", true);
  }
addDocument(event: any) {
  if (event.target.checked) { 
    this.capaDocRefs.push(...this.implementationDocRefs);
    this.bothCapaAndImplementation= true;
  } else { 
    this.capaDocRefs = this.capaDocRefs.filter(
      doc => !this.implementationDocRefs.includes(doc)
    );
    this.bothCapaAndImplementation= false;
  }
}
  areAllImplementationDocsAttached(): boolean { 
return this.documents.some(doc => doc.referenceID === 70) 
                   && this.documents.some(doc => doc.referenceID === 103); 
 }


  submitCAPA(){
    this.spinner.show();
    this.inspectionService.submitCapa(this.inspection.id).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success("CAPA Plan Submitted Successfully!");
        this.router.navigate([this.inspectionService.getInspectionListUrl(this.inspection)]);
      }else {
        this.alertService.error("CAPA Plan Couldn't be Submitted, Try again!");
      }
    }, err => {
      this.spinner.hide(); 
      this.alertService.error("CAPA Plan Couldn't be Submitted, Try again!");
    })
  } 
    submitCAPAAndImplementation(){
    this.spinner.show();
    this.inspectionService.submitCapaAndImplementation(this.inspection.id).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success("CAPA Plan and Implementation Evidence Submitted Successfully!");
        this.router.navigate([this.inspectionService.getInspectionListUrl(this.inspection)]);
      }else {
        this.alertService.error("CAPA Plan and Implementation Evidence Couldn't be Submitted, Try again!");
      }
    }, err => {
      this.spinner.hide(); 
      this.alertService.error("CAPA Plan and Implementation Evidence Couldn't be Submitted, Try again!");
    })
  } 
  onSubmit() {
    console.log("here");
    console.log(this.areAllImplementationDocsAttached());
  if (this.areAllImplementationDocsAttached()) {
    this.submitCAPAAndImplementation();
  } else {
    this.submitCAPA();
  }
}

  submitImplementationReport(){
    this.spinner.show();
    this.inspectionService.submitImplementationReport(this.inspection.id).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success("Implementation Report Submitted Successfully!");
        this.router.navigate([this.inspectionService.getInspectionListUrl(this.inspection)]);
      }else {
        this.alertService.error("Implementation Report Couldn't be Submitted, Try again!");
      }
    }, err => {
      this.spinner.hide(); 
      this.alertService.error("Implementation Report Couldn't be Submitted, Try again!");
    })
  }

  isFieldEdited() {
    if(this.inspection.differentProductionLine){
      return {'highlight-text': true};
    }
  }

  isFileAttached(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;

    }).findIndex((elt) => {

      return elt === docRefID;
    });
    if (idx !== -1) {
      return true;
    } else {
      return false;
    }
  }

  previewModal(modalName: string, docRefID: number, fileIndex: number) {
    let doc = this.getDocument(docRefID)
    const attachmentUrl = SubDataVariables.INSPECTION_DOC_URL + '/' + doc.id;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  getDocument(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;

    }).findIndex((elt) => {

      return elt === docRefID;
    });

    if (idx !== -1) {
      return this.attachedDocs[idx];
    } else {
      return null;
    }
  }

  downloadAttachment(name: string, docRefID: number, fileIndex: number) {
    let  doc = this.getDocument(docRefID);

    this.inspectionService.getAttachmentByID(doc.id).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/pdf'
      });
      saveAs(blob, name);
    });
  }

  getFileName(docRefID, fileIndex) {
    let doc = this.getDocument(docRefID);
    if (doc) {
      let fileName = doc.filePath.replace(/^.*[\\\/]/, '');
      if (!fileName.length) {
        fileName = '-';
      }
      return fileName;
    }
    return '-';
  }

  getUploadTime(docRefID, fileIndex) {
    let doc = this.getDocument(docRefID);

    if (doc) {
      return this.getDateString(doc.modifiedDate);
    }

    return '-';
  }

  getRecieptNumber(docRefID, fileIndex) {
    if (docRefID === Constants.PAYMENT_REFERENCE_ID || docRefID === Constants.GMP_FINAL_PAYMENT_REFERENCE_ID
       || docRefID === Constants.BANK_TRANSFER_SLIP_REFERENCE_ID || docRefID === Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID 
      || docRefID === Constants.GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID || docRefID === Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID) {
      let doc = this.getDocument(docRefID);
      if (doc) {
        const paymenInfo = this.inspection.inspectionPayment.find(function (x) {
          return x.documentID === doc.id;
        });
        if (paymenInfo) {
          return paymenInfo.recieptNumber;
        }
      }
    }

    return '';
  }

  getInspectionHistory(id) {
    if (!id) return;
    this.inspectionService.getInspectionHistory(id).subscribe(res => {
      this.historyLog = Array.isArray(res) ? res : [];
      this.hasPartialApprovalRecommend = this.historyLog.some(
        h => (h.oldCode === IST.PARTIAL_APPROVAL_RECOMMENDED) || (h.oldCode === IST.RECOMMENDED_FOR_PARTIAL_APPROVAL_AFTER_IMPLEMENTATION_EVIDENCE)
      );
    }, err => {
      console.error('getInspectionHistory failed', err);
      this.historyLog = [];
    });
  }
  GetInspectionProcessingTime(id){
    this.inspectionService.getInspectionProcessingTime(id).subscribe(res => {
      this.inspectionProcessingTime = res;  
  }); 
  }

  onEnketoFormClosed(closed: boolean){
    if(closed){
      this.showEnketoForm = false;
    }
  }

  disableSubmitScreeningResponseButton() : boolean{
    for (let i = 0; i < this.inspection.screeningChecklists.length; i++) {
      if (!this.inspection.screeningChecklists[i].screenerResponseValue.name) {
        return true;
      }
    }
    return !this.inspection.screenerResponseSummary;
  }

  submitScreeningResponse(){
    this.inspection.screeningChecklists.forEach(c => c.inspectionID = this.inspection.id);
    let model = {'checklistInstances' : this.inspection.screeningChecklists,
      'screeningSummary': this.inspection.screenerResponseSummary}
    this.spinner.show();
    this.inspectionService.submitScreenerResponse(model).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.router.navigate([this.inspectionService.getInspectionListUrl(this.inspection)]);
        this.alertService.success("Screening Response Successfully Submitted!")
      } else {
        this.alertService.error("Failed to Submit Screening Response, please try again!")
      }
    }, error => {
      this.alertService.error("Failed to Submit Screening Response, please try again!")
      this.spinner.hide();
    });
  }

  editInspection() {
    switch(this.inspection.type.inspectionTypeCode){
      case ITPS.NEW_LOCAL_GMP_INSPECTION:
      case ITPS.LOCAL_GMP_RENEWAL_INSPECTION:
        this.router.navigateByUrl('inspections/localGMP/edit/'+ this.inspection.type.inspectionTypeCode + '/' + this.inspection.id);
        break;
      case ITPS.NEW_ABROAD_CGMP_INSPECTION:
      case ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER:
        this.router.navigateByUrl('inspections/abroadCGMP/edit/'+ this.inspection.type.inspectionTypeCode + '/' + this.inspection.id + '/false');
        break;
      case ITPS.ABROAD_CGMP_RENEWAL_INSPECTION:
      case ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL:
        this.router.navigateByUrl('inspections/abroadCGMP/renewal/edit/'+ this.inspection.type.inspectionTypeCode + '/' + this.inspection.id);
        break;
    }
  }

  withdrawButtonShouldShow() {
    return this.inspection && ( ((this.isAbroadCGMP || [ITPS.NEW_LOCAL_GMP_INSPECTION, ITPS.LOCAL_GMP_RENEWAL_INSPECTION].indexOf(
      this.inspection.type.inspectionTypeCode) > -1) && (this.accountService.getUserData().id === this.inspection.createdBy) &&
      this.inspection.status.inspectionStatusCode == IST.REQUESTED_CODE) || this.showWithdrawForPostLicensingInsp());
  }

  showWithdrawForPostLicensingInsp(){
    return this.inspection.type.inspectionTypeCode == ITPS.POST_LICENSING_INSPECTION &&
      this.inspection.status.inspectionStatusCode == IST.ASSIGNED_TO_INSPECTOR &&
      this.accountService.getUserData().id === this.inspection.createdBy;
  }
  addPaymentLetter(){
    const filteredDocuments = this.attachedDocs.filter(doc =>
      ["Payment Request", Constants.BANK_TRANSFER_SLIP, Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE].includes(doc.documentReference.name)
);

      // filteredDocuments.forEach(doc => {
      //   if (doc.documentReference) {
      //     this.documentRefs.push(doc.documentReference);
      //   }
      // });
      
  var paymentDoc = this.attachedDocs.find(doc => doc.documentReference.name == Constants.PAYMENT_REQUEST_DOC_NAME)
    if (paymentDoc){
      var paymentDocRef = paymentDoc.documentReference
       this.documentRefs.push(paymentDocRef)
      }
  }

  getCapaDueDate(){
    let capas = this.inspection.inspectionCapas.sort((a, b) => b.id - a.id); //latest capa first
    if(capas.length > 0 && capas[0].capaDueDate){
      return this.getDateString(capas[0].capaDueDate);
    }
    return null;
  }

  getImplementationReportDueDate(){
    let capas = this.inspection.inspectionCapas.sort((a, b) => b.id - a.id);
    if(capas.length > 0 && capas[0].implementationReportDueDate){
      return this.getDateString(capas[0].implementationReportDueDate);
    }
    return null;
  }

  isInCapaPlanPhase(){
    return [IST.CAPA_PLAN_REQUESTED, IST.CAPA_PLAN_SUBMITTED, IST.CAPA_PLAN_REJECTED]
      .indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  isInCapaImplementationPhase(){
    return [IST.IMPLEMENTATION_REPORT_REQUESTED, IST.IMPLEMENTATION_REPORT_SUBMITTED, IST.IMPLEMENTATION_REPORT_REJECTED]
      .indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  onWorkflowSelectedAction(workflowAction: WorkflowActionModel) { 
    if(workflowAction.event == 'edit') {
      this.editInspection();
    } else if(workflowAction.event == 'regenerateDocument') {
      this.regenerateIinspectDocumentAtCurrentStatus(this.inspection.id);
    } else{
      if(workflowAction.to == IST.FINAL_FILE_SUBMITTED_CODE) {
        if(this.isSubmitFileDisabled()) {
          this.alertService.error("Please upload the files first!");
          return;
        }
      } else if([IST.INSPECTED_CODE, IST.INSPECTION_FAILED_CODE
        ,IST.CAPA_PLAN_RECOMMEND,IST.INSPECTION_REPORT_SUBMITED].includes(workflowAction.to)) { 
        if(this.isRequiredDocUploaded()) {
          this.alertService.error("Please upload the files first!");
          return;
        }
      }
      this.showStatusChangeModal(workflowAction.to);
    }
  }

  onWorkflowLoaded(workflows: WorkflowActionModel[]) {
    let transitionTos = workflows.map(w => w.to); 
    //tab control
    if(transitionTos.includes(IST.CAPA_PLAN_SUBMITTED)) {
      this.showCapaAttachmentTab = true;
      this.activateTab("capaAttachment");
      this.editDocuments = this.inspection.documents.filter(d => (d.documentReference.name == Constants.CAPA_DOC_NAME ||d.documentReference.name == Constants.IMPLEMNTATION_REPORT_DOC_NAME  ));// capa document
    
      if(this.editDocuments.length >=0){
        this.bothCapaAndImplementation= true;
          this.capaDocRefs.push(...this.implementationDocRefs); 
      }
    } else if(transitionTos.includes(IST.FINAL_FILE_SUBMITTED_CODE)) {
      this.showSubmitFileForPreparationActions = true;
      this.inspectionService.getGMPFinalDocumentRefs(this.isLocalGMP).subscribe(documentRefsResp => {
        this.finalFileDocRefs = documentRefsResp;
      });
      this.activateTab("finalFileAttachment");
      
    } else if(transitionTos.includes(IST.FINAL_PAYMENT_ATTACHED)){
      this.configureGmpFinalPaymentUpload();
      if(this.isGMP && !this.isAbroadWaiver){
        this.showUploadFeeTab = true;
        this.isMultiPaymentUpload = true;
        this.isGMPFinalPayment = true;
        this.editDocuments = this.inspection.documents.filter(d => d.documentReference.id == Constants.GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID
          || d.documentReference.id == Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID);
        this.activateTab("uploadFee");
      } else if(this.isAbroadWaiver){
        this.showPaymentTab = true;
        this.isGMPFinalPayment = true;
        this.isMultiPaymentUpload = false;
        this.editDocuments = this.inspection.documents.filter(d => d.documentReference.name == Constants.GMP_FINAL_PAYMENT_DOC_NAME);
        this.activateTab("feeAttachment");
      }
      
    } else if(transitionTos.includes(IST.FEE_ATTACHED)) { 
      if(this.isAbroadOnly){
     this.showUploadFeeTab= true; 
     this.isMultiPaymentUpload=true;
      this.editDocuments = this.inspection.documents.filter(d => d.documentReference.name ==  Constants.BANK_TRANSFER_SLIP || d.documentReference.name == Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE);
      this.activateTab("uploadFee");
      }
      else{
     this.showPaymentTab = true;
      this.editDocuments = this.inspection.documents.filter(d => d.documentReference.name ==  Constants.PAYMENT_DOC_NAME|| d.documentReference.name ==  Constants.BANK_TRANSFER_SLIP || d.documentReference.name == Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE);
      this.activateTab("feeAttachment");
      }
   
    } else if(transitionTos.includes(IST.IMPLEMENTATION_REPORT_SUBMITTED)) {
      this.showImplementationReportAttachmentTab = true;
      this.editDocuments = this.inspection.documents.filter(d => d.documentReference.name == Constants.IMPLEMNTATION_REPORT_DOC_NAME);
      this.activateTab("implementationReportAttachment");
    } 
     else if(transitionTos.includes(IST.TENTATIVE_PLAN_SUBMIT)) {
      this.showTentativePlanAttachmentTab = true;
      this.inspectionService.getTentativePlanDocumentRefs(this.isLocalGMP).subscribe(documentRefsResp => {
        this.finalFileDocRefs = documentRefsResp;
      });
        this.activateTab("tentativePlanAttachment");
    }
      else if(transitionTos.includes(IST.INSPECTION_REPORT_SUBMITED)) {
      this.showInspectionReportAttachmentTab = true;
      this.inspectionService.getInspectionReportDocumentRefs(false).subscribe(documentRefsResp => {
        this.finalFileDocRefs = documentRefsResp;
      });
        this.activateTab("inspectionReportAttachment");
    }
         else if(transitionTos.includes(IST.TASK_FORCE_REVIEW_REPORT_UPDATED)) {
      this.showTaskReviewUpdateAttachmentTab = true;
      this.inspectionService.getInspectionReportDocumentRefs(true).subscribe(documentRefsResp => {
        this.finalFileDocRefs = documentRefsResp; 
      }); 
        this.activateTab("taskReviewUpdateAttachment");
    }
    
   
    if(transitionTos.includes(IST.INSPECTED_CODE) || transitionTos.includes(IST.INSPECTION_FAILED_CODE)) {
      this.showInspectionActions = true;
      if(this.isGMP) {
        this.inspectionService.getGMPInspectionDocRefs().subscribe(documentRefsResp => {
          this.inspectionDocRefs = documentRefsResp;
          this.inspectionDocRefs.reverse();
        });
        this.activateTab("uploadInspectionResult");
      }
    }
  }
 getActualInspectionStartDate(data: InspectionAssignment[]) {
    let assignment = data.find(x => x.actualStartDate != null);
    if(assignment && assignment.actualStartDate){
      return this.getDateString(assignment.actualStartDate)
    }
      else return '--';
  }
   getActualInspectionEndDate(data: InspectionAssignment[]) {
    let assignment =  data.find(x => x.actualDueDate != null) ;
    if(assignment && assignment.actualDueDate){
      return this.getDateString(assignment.actualDueDate)
    }
    else return '--';
  }
  getInspectionStartDate(data: InspectionAssignment[]) {
    let assignment = data.find(d => d.primary == true && d.assignmentType == "INSPECTION");
    if(assignment && assignment.startDate){
      return this.getDateString(assignment.startDate)
    }
  }

  getInspectionDueDate(data: InspectionAssignment[]) {
    let assignment = data.find(d => d.primary == true && d.assignmentType == "INSPECTION");
    if(assignment && assignment.dueDate) {
      return this.getDateString(assignment.dueDate)
    }
  } 

hasCapaRecommendedProdLines(): boolean {  
  const prodLines = this.inspection?.productionInfo?.['prodInfoProdLines'];
 return Array.isArray(prodLines) && prodLines.some((prod: any) => prod?.isCAPARecommended === true); 
}
hasExemptedProdLines(): boolean {   
  const prodLines = this.inspection?.productionInfo?.['prodInfoProdLines'];
 return Array.isArray(prodLines) && prodLines.some((prod: any) => prod?.isExempted === true); 
}
hasApprovedProdLines(): boolean {   
  const prodLines = this.inspection?.productionInfo?.['prodInfoProdLines'];
 return Array.isArray(prodLines) && prodLines.some((prod: any) => prod?.isApproved === true); 
}

  canEditRtiInspectionDocuments(): boolean {
    return this.inspection?.status?.inspectionStatusCode === IST.RETURN_TO_INSPECTOR_CODE
      && this.isGMP
      && this.accountService.isUserGMPInspector()
      && this.isCurrentUserAssignedInspector();
  }

  isCurrentUserAssignedInspector(): boolean {
    const userId = this.accountService.getUserData()?.id;
    return (this.inspection?.inspectionAssignments ?? []).some(a => a.userID === userId);
  }

  private readonly taskForceReviewReportUpdatedStatus = 'Task Force Review Report Updated';

  getTaskForceUpdatedInspectionDocuments(): DocumentDetail[] {
    const taskForceResults = (this.inspection?.inspectionResults ?? [])
      .filter(r => r.statusName === this.taskForceReviewReportUpdatedStatus);

    if (!taskForceResults.length) {
      return [];
    }

    const latestTaskForceResult = taskForceResults.reduce((latest, current) =>
      current.id > latest.id ? current : latest);

    const byRef = new Map<number, any>();
    (latestTaskForceResult.inspectionResultDocuments ?? []).forEach(resultDoc => {
      const doc = resultDoc?.inspectionDocument;
      const docName = doc?.documentReference?.name;
      if (!docName || !this.rtiInspectionReportDocNames.has(docName)) {
        return;
      }
      const existing = byRef.get(doc.referenceID);
      if (!existing || doc.id > existing.id) {
        byRef.set(doc.referenceID, doc);
      }
    });

    return Array.from(byRef.values()).map(d => new DocumentDetail(d));
  }

  setupRtiDocumentEdit(): void {
    this.showRtiInspectionDocumentEdit = false;
    this.rtiInspectionDocRefs = [];
    this.rtiEditDocuments = [];
    this.rtiDocuments = [];

    if (!this.canEditRtiInspectionDocuments()) {
      return;
    }

    this.rtiEditDocuments = this.getTaskForceUpdatedInspectionDocuments();
    if (!this.rtiEditDocuments.length) {
      return;
    }

    this.showTaskReviewUpdateAttachmentTab = true;

    const editableRefIds = new Set(this.rtiEditDocuments.map(d => d.referenceID));
    this.inspectionService.getInspectionReportDocumentRefs(true).subscribe(refs => {
      this.rtiInspectionDocRefs = refs.filter(r => editableRefIds.has(r.id));
      this.showRtiInspectionDocumentEdit = this.rtiInspectionDocRefs.length > 0;
      if (this.showRtiInspectionDocumentEdit) {
        this.activateTab('taskReviewUpdateAttachment');
      }
    });
  }

  saveRtiInspectionDocuments(): void {
    if (!this.rtiDocuments.length) {
      this.alertService.error('Please upload at least one revised document.');
      return;
    }
    if (this.uploaderLargeFile?.isUploading) {
      return;
    }
    this.spinner.show();
    this.inspectionService.updateInspectorInspectionDocuments({
      inspectionID: this.inspection.id,
      documents: this.rtiDocuments.map(d => ({ id: d.id, referenceID: d.referenceID }))
    }).subscribe(() => {
      this.spinner.hide();
      this.alertService.success('Inspection documents updated successfully.');
      this.rtiDocuments = [];
      this.getInspection();
    }, err => {
      this.spinner.hide();
      const message = err?.error?.Message || err?.error?.message;
      this.alertService.error(message || 'Could not update inspection documents. Please try again.');
    });
  }

  fillKeyPersons() {
    const abroadFacility = this.inspection?.inspectionAbroadFacility?.[0]?.abroadFacility;
    if (!abroadFacility) {
      this.keyPersons = [];
      return;
    }
    let types = ["Manufacturer Contact", "Quality Assurance", "Quality Control", "Product Manager", "International Marketing",
      "Regularity Affair", "Owner"]

    for(let type of types) {
      let fieldNamePrefix = type.split(" ").map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())).join("");
      let obj = {};
      obj["name"] = abroadFacility[fieldNamePrefix+"Name"];
      if(!obj["name"]) {
        continue;
      }
      obj["email"] = abroadFacility[fieldNamePrefix+"Email"];
      obj["phone"] = abroadFacility[fieldNamePrefix+"Phone"];
      obj["type"] = type;
      this.keyPersons.push(obj);
    }
  }

  openAlertModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  deleteQRCodeDocument(){
    this.spinner.show();
    this.inspectionService.deleteQRCodeDocument(this.inspection.id).subscribe(resp => {
      this.spinner.hide();
      this.closeModal();
      if(resp){
        this.alertService.success("Inspection QR Code document Deleted successfully!");
        this.router.navigateByUrl('/inspections/postLicensing/list/PLI');
      } else {
        this.alertService.success("Couldn't delete the Inspection QR Code document!");
      }
    }, err => {
      this.spinner.hide();
      this.closeModal();
      this.alertService.success("Couldn't delete the Inspection QR Code document!");
    })
  }

  closeModal() {
    this.modalRef.hide();
  }

  isExpanded(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    return index !== -1;
  }

  expandOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    if (index !== -1) {
      return;
    }

    this.expandedProdDetailIds.push(prodDetailId);
  }

  collapseOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);

    if (index !== -1) {
      this.expandedProdDetailIds.splice(index, 1);
    }
  }

  joinLookupTypes(array: any[]) {
    if(!array || array.length == 0) {
      return "-";
    }
    return array.map(q => q.name).join(" , ");
  }

  getDosageForms(): string {
    const dosageForms = this.inspection.productionInfo.prodInfoDosageForms;
    return dosageForms.length > 0 ? this.joinLookupTypes(dosageForms.map(a => a.dosageForm)) : '-';
  }

  regenerateIinspectDocumentAtCurrentStatus(inspectionId: number) {
    this.spinner.show();
    this.inspectionService.regenerateIinspectDocumentAtCurrentStatus(inspectionId).subscribe(resp => {
      this.spinner.hide();
      if (resp) {
        this.alertService.success("Successfully Regenerated! check after thirty seconds");
      } else {
        this.alertService.error("Failed to Regenerate document, please try again!");
      }
    }, error => {
      this.spinner.hide();
      this.alertService.error("Failed to Regenerate document, please try again!")
    });
  }
}
